module.exports = __webpack_public_path__ + "img/slicedlime-4c2c2554-80b5-4e3b-36c5-08d96016209d.png";